import React from 'react';
import {Field} from 'redux-form/immutable';
import {TextField, SelectField} from 'redux-form-antd'

import {
    required,
    nullValue1
} from "../validDesc";

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
const MonParentalStatus = props => {
    const default_select = [
        {
            value: '-1',
            label: '請選擇'
        },
        {
            value: '1',
            label: '是'
        },
        {
            value: '2',
            label: '否'
        }
    ]
    const ｄisability_select = [
        {
            value: '-1',
            label: '請選擇'
        },
        {
            value: '1',
            label: '無'
        },
        {
            value: '2',
            label: '有-輕度'
        },
        {
            value: '3',
            label: '有-中度'
        },
        {
            value: '4',
            label: '有-重度'
        },
        {
            value: '5',
            label: '有-極重度'
        }
    ]
    return (
        <div>
            <h3>請問母親是否有以下之身分：</h3>
            <div className="ml-20">
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='是否有本國國籍'
                       options={default_select} name="moth_national" type="text" disabled={false} ></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='是否為軍公教遺族'
                       options={default_select} name="moth_military" type="text" disabled={false} ></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='是否有領有身心殘障手冊'
                       options={ｄisability_select} name="moth_disability" type="text" disabled={false} ></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='是否為大陸籍'
                       options={default_select} name="moth_continental" type="text" disabled={false} ></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='是否為低收入戶'
                       options={default_select} name="moth_low_income" type="text" disabled={false} ></Field>
                <Field {...formItemLayout} component={TextField} label="原住民族別"
                       name="moth_aboriginal_people" type="text"></Field>
                <Field {...formItemLayout} component={TextField} label="其他國籍"
                       name="moth_foreigner" type="text"></Field>
            </div>
        </div>
    )
}

export default MonParentalStatus


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ParentalStatusSurveyContaioner/ParentalStatusSurveyForm/MonParentalStatus.jsx